import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=ccc3edda&scoped=true&lang=pug"
import script from "./StartPage.vue?vue&type=script&lang=js"
export * from "./StartPage.vue?vue&type=script&lang=js"
import style0 from "./StartPage.vue?vue&type=style&index=0&id=ccc3edda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc3edda",
  null
  
)

export default component.exports